import script from "./DeletedRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./DeletedRecords.vue?vue&type=script&setup=true&lang=js"

import "./DeletedRecords.vue?vue&type=style&index=0&id=65f4b4a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f4b4a4"]])

export default __exports__